import { Outlet, NavLink } from "react-router-dom";
import Seo from './Seo'
// import { useSelector, useDispatch } from 'react-redux';
// import { ChangeByPayload } from '../store/ActiveLinkLogic';

import ImgFb from '../img/img_fb.jpg';

const ContattiPage = () => {
return(
<>
<Seo
title = "Contatti e Preventivi Grafica, Social e Video Perugia e Roma | Lorenzo Giralda"
description = "Richiedi un preventivo gratuito per i tuoi progetti di grafica, gestione social e produzione video. Contattami per una consulenza a Perugia, Roma o da remoto."
keywords = "contatti lorenzo giralda, preventivo grafico perugia, agenzia social roma, consulenza comunicazione visiva, telefono grafico pubblicitario"
url="https://giralda-design.web.app/contatti"
immagine={ImgFb}
></Seo>

<Outlet></Outlet>
</>
)};

export default ContattiPage;